import { render, staticRenderFns } from "./MemberOrderRecords.vue?vue&type=template&id=0bd8098e&scoped=true&"
import script from "./MemberOrderRecords.vue?vue&type=script&lang=js&"
export * from "./MemberOrderRecords.vue?vue&type=script&lang=js&"
import style0 from "./MemberOrderRecords.vue?vue&type=style&index=0&id=0bd8098e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd8098e",
  null
  
)

export default component.exports